import { ReactElement } from 'react';
import stepOne from 'consumer/components/progress-bar/step-01.webp';
import stepOne2x from 'consumer/components/progress-bar/step-01@2x.webp';
import stepTwo from 'consumer/components/progress-bar/step-02.webp';
import stepTwo2x from 'consumer/components/progress-bar/step-02@2x.webp';
import stepThree from 'consumer/components/progress-bar/step-03.webp';
import stepThree2x from 'consumer/components/progress-bar/step-03@2x.webp';
import stepFour from 'consumer/components/progress-bar/step-04.webp';
import stepFour2x from 'consumer/components/progress-bar/step-04@2x.webp';
import stepFive from 'consumer/components/progress-bar/step-05.webp';
import stepFive2x from 'consumer/components/progress-bar/step-05@2x.webp';
import stepSix from 'consumer/components/progress-bar/step-06.webp';
import stepSix2x from 'consumer/components/progress-bar/step-06@2x.webp';

type Props = {
  currentStepNum?: number;
};

function ProgressBar({ currentStepNum = 0 }: Props): ReactElement {
  const progressIcon = (imgUrl1x, imgUrl2x) => (
    <img
      src={imgUrl1x}
      srcSet={`${imgUrl1x} 1x, ${imgUrl2x} 2x`}
      className="c-progress-step__icon"
      alt={`progress-step-${currentStepNum}`}
    />
  );
  const progressBarDescriptions = ['PREFERENCE QUIZ', 'PREFERENCE QUIZ', 'SELECT PLAN', 'CREATE ACCOUNT', 'ENTER ADDRESS', 'ADD PAYMENT'];

  return (
    <>
      <div className="c-progress-container">
        <div className={`c-progress-step c-progress-step__first ${currentStepNum >= 1 ? 'is-completed' : ''}`}>
          {currentStepNum === 1 && (progressIcon(stepOne, stepOne2x))}
        </div>
        <div className={`c-progress-step ${currentStepNum >= 2 ? 'is-completed' : ''}`}>
          {currentStepNum === 2 && (progressIcon(stepTwo, stepTwo2x))}
        </div>
        <div className={`c-progress-step ${currentStepNum >= 3 ? 'is-completed' : ''}`}>
          {currentStepNum === 3 && (progressIcon(stepThree, stepThree2x))}
        </div>
        <div className={`c-progress-step ${currentStepNum >= 4 ? 'is-completed' : ''}`}>
          {currentStepNum === 4 && (progressIcon(stepFour, stepFour2x))}
        </div>
        <div className={`c-progress-step ${currentStepNum >= 5 ? 'is-completed' : ''}`}>
          {currentStepNum === 5 && (progressIcon(stepFive, stepFive2x))}
        </div>
        <div className={`c-progress-step c-progress-step__last ${currentStepNum >= 6 ? 'is-completed' : ''}`}>
          {currentStepNum === 6 && (progressIcon(stepSix, stepSix2x))}
        </div>
      </div>
      <div className="c-progress-description__container">
        <div className="c-progress-description__step-number">
          {`Step ${currentStepNum}`}
        </div>
        <div className="c-progress-description__step-description">
          {`/ 6: ${progressBarDescriptions[currentStepNum - 1] || ''}`}
        </div>
      </div>
    </>
  );
}

export default ProgressBar;
